import {
    Box, Button, ButtonGroup, Dialog, DialogActions, DialogContent, DialogTitle,
    TextField, Icon, Typography, CircularProgress, Select, MenuItem, InputLabel, FormControl, Checkbox
} from '@mui/material';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import React, { useEffect, useState, useRef } from 'react';
import AptaTable from 'examples/AptaTable';
import axios from 'axios';
import { URL } from 'constants/constant';
import Swal from 'sweetalert2';

const Quiz = () => {
    const [details, setDetails] = useState({
        question: "",
        dayId: "",
        options: [
            { title: "", correct: false },
            { title: "", correct: false },
            { title: "", correct: false },
            { title: "", correct: false }
        ],
        image: null
    });
    const [open, setOpen] = useState(false);
    const [quizzes, setQuizzes] = useState([]);
    const [formType, setFormType] = useState('add');
    const [loading, setLoading] = useState(false);
    const [days, setDays] = useState([]);
    const [viewModal, setViewModal] = useState(false);
    const [viewDetails, setViewDetails] = useState(null);
    const fileInputRef = useRef(null);

    const handleOpen = (type, item = null) => {
        setFormType(type);
        if (item) {
            setDetails({
                _id: item._id,
                question: item.question,
                dayId: item.dayId?._id || item.dayId || "",
                options: item.options || [
                    { title: "", correct: false },
                    { title: "", correct: false },
                    { title: "", correct: false },
                    { title: "", correct: false }
                ],
                image: item.image || null
            });
        } else {
            setDetails({
                question: "",
                dayId: "",
                options: [
                    { title: "", correct: false },
                    { title: "", correct: false },
                    { title: "", correct: false },
                    { title: "", correct: false }
                ],
                image: null
            });
        }
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    const handleSave = async (data) => {
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append("question", data.question);
            formData.append("dayId", data.dayId);
            formData.append("options", JSON.stringify(data.options));
            if (data.image && data.image instanceof File) {
                formData.append("image", data.image);
            }
            if (formType === 'add') {
                await axios.post(`${URL}/api/admin/quiz`, formData);
                Swal.fire("Quiz created!");
            } else {
                await axios.patch(`${URL}/api/admin/quiz/${data._id}`, formData);
                Swal.fire("Quiz updated!");
            }
            handleClose();
            getQuizzes();
        } catch (error) {
            Swal.fire("Something went wrong!");
            console.error("Save error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This will delete the quiz permanently.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.delete(`${URL}/api/admin/quiz/${id}`);
                    Swal.fire("Deleted successfully!");
                    getQuizzes();
                } catch (error) {
                    console.error("Delete error:", error);
                }
            }
        });
    };

    const getQuizzes = async () => {
        try {
            const res = await axios.get(`${URL}/api/admin/quiz`);
            setQuizzes(res.data.data || []);
        } catch (err) {
            console.log(err.message);
        }
    };

    const getDays = async () => {
        try {
            const res = await axios.get(`${URL}/api/admin/day`);
            setDays(res.data.data || []);
        } catch (err) {
            console.log(err.message);
        }
    };

    useEffect(() => {
        getQuizzes();
        getDays();
    }, []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Box display="flex" mb={3} justifyContent="end">
                <Button
                    startIcon={<Icon>add</Icon>}
                    variant="contained"
                    color="primary"
                    style={{ color: 'white' }}
                    onClick={() => handleOpen('add')}
                >
                    Add Question
                </Button>
            </Box>

            <AptaTable
                columns={[
                    'Question',
                    'Day',
                    'Image',

                    'View',
                    'Actions'
                ]}
                rows={quizzes?.map((item) => ({
                    Question: (
                        <Typography variant="subtitle2" color="primary">
                            {item?.question}
                        </Typography>
                    ),
                    Day: (
                        <Typography variant="body2" color="secondary">
                            {item?.dayId?.name || ""}
                        </Typography>
                    ),

                    Image: item.image ? (
                        <a href={`${URL}/${item.image}`} target="_blank" rel="noopener noreferrer">
                            <img
                                src={`${URL}/${item.image}`}
                                alt="quiz"
                                style={{
                                    width: 48,
                                    height: 48,
                                    objectFit: 'cover',
                                    borderRadius: 8,
                                    border: '1px solid #eee'
                                }}
                            />
                        </a>
                    ) : (
                        <Typography variant="caption" color="textSecondary">No Image</Typography>
                    ),
                    View: <Button color='info' onClick={() => { setViewDetails(item); setViewModal(true); }}
                    >
                        <Icon color='info'>visibility</Icon>
                    </Button>,
                    Actions: <ButtonGroup size='small'>
                        <Button color='info' onClick={() => handleOpen('edit', item)}>
                            <Icon color='info'>edit</Icon>
                        </Button>
                        <Button color="error" onClick={() => handleDelete(item?._id)}>
                            <Icon color='error'>delete</Icon>
                        </Button>
                    </ButtonGroup>

                    // View and Actions columns handled by custom render above
                }))}
            />

            <InputFormModal
                open={open}
                onClose={handleClose}
                onSave={handleSave}
                details={details}
                type={formType}
                setDetails={setDetails}
                loading={loading}
                days={days}
                fileInputRef={fileInputRef}
            />

            <ViewQuizModal
                open={viewModal}
                onClose={() => setViewModal(false)}
                details={viewDetails}
                days={days}
            />
        </DashboardLayout>
    );
};

export default Quiz;

const InputFormModal = ({ open, onClose, onSave, details, setDetails, type, loading, days, fileInputRef }) => {
    useEffect(() => {
        if (open && type === 'add') {
            setDetails({
                question: "",
                dayId: "",
                options: [
                    { title: "", correct: false },
                    { title: "", correct: false }
                ],
                image: null
            });
        }
    }, [open, type, setDetails]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDetails({ ...details, [name]: value });
    };

    const handleOptionChange = (idx, field, value) => {
        let newOptions = [...details.options];
        if (field === "correct") {
            // Only one correct answer allowed
            newOptions = newOptions.map((opt, i) => ({
                ...opt,
                correct: i === idx ? value : false
            }));
        } else {
            newOptions[idx][field] = value;
        }
        setDetails({ ...details, options: newOptions });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setDetails({ ...details, image: file });
        }
    };

    const handleAddOption = () => {
        setDetails({
            ...details,
            options: [...details.options, { title: "", correct: false }]
        });
    };

    const handleRemoveOption = (idx) => {
        if (details.options.length <= 2) return;
        const newOptions = details.options.filter((_, i) => i !== idx);
        setDetails({ ...details, options: newOptions });
    };

    const handleSave = () => {
        onSave(details);
    };

    return (
        <Dialog open={open} maxWidth="sm" fullWidth onClose={onClose}>
            <DialogTitle>{type === 'add' ? 'Add Question' : 'Edit Question'}</DialogTitle>
            <DialogContent>
                <TextField
                    label="Question"
                    name="question"
                    value={details.question}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    disabled={loading}
                />
                <FormControl fullWidth margin="normal" disabled={loading}>
                    <InputLabel id="dayId-label">Day</InputLabel>
                    <Select
                        labelId="dayId-label"
                        name="dayId"
                        value={details.dayId}
                        label="Day"
                        style={{ minHeight: 40, marginBottom: 5 }}
                        onChange={(e) => setDetails({ ...details, dayId: e.target.value })}
                    >
                        {days.map((day) => (
                            <MenuItem key={day._id} value={day._id}>{day.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {details.options.map((opt, idx) => (
                    <Box key={idx} display="flex" alignItems="center" gap={1} mb={1}>
                        <TextField
                            label={`Option ${idx + 1}`}
                            value={opt.title}
                            onChange={(e) => handleOptionChange(idx, "title", e.target.value)}
                            fullWidth
                            disabled={loading}
                        />
                        <Checkbox
                            checked={opt.correct}
                            onChange={(e) => handleOptionChange(idx, "correct", e.target.checked)}
                            disabled={loading}
                            color="primary"
                        />
                        {details.options.length > 2 && (
                            <Button
                                color="error"
                                onClick={() => handleRemoveOption(idx)}
                                disabled={loading}
                            >
                                Remove
                            </Button>
                        )}
                    </Box>
                ))}
                <Box mt={1} mb={2}>
                    <Button
                        onClick={handleAddOption}
                        disabled={loading}
                    >
                        Add Option
                    </Button>
                </Box>
                <Box mt={2}>
                    <Button
                        variant="contained"
                        component="label"
                        disabled={loading}

                        style={{ color: 'white' }}
                    >
                        {details.image && details.image.name
                            ? `Selected: ${details.image.name}`
                            : "Upload Image"}
                        <input
                            type="file"
                            accept="image/*"
                            hidden
                            ref={fileInputRef}
                            onChange={handleFileChange}
                        />
                    </Button>
                    {type === 'edit' && typeof details.image === 'string' && (
                        <Typography variant="caption" color="textSecondary" ml={2}>
                            Current: <a href={`${URL}/${details.image}`} target="_blank" rel="noopener noreferrer">{details.image.split('/').pop()}</a>
                        </Typography>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" disabled={loading}>
                    Cancel
                </Button>
                {loading ? (
                    <Box sx={{ px: 2, py: 1 }}>
                        <CircularProgress size={24} />
                    </Box>
                ) : (
                    <Button
                        onClick={handleSave}
                        color="primary"
                        variant="contained"
                        style={{ color: 'white' }}
                        disabled={
                            !details.question ||
                            !details.dayId ||
                            details.options.length < 2 ||
                            details.options.some(opt => !opt.title) ||
                            details.options.filter(opt => opt.correct).length !== 1
                        }
                    >
                        Save
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

// View Modal for Quiz
const ViewQuizModal = ({ open, onClose, details, days }) => {
    if (!details) return null;
    const dayName = days.find(d => d._id === (details.dayId?._id || details.dayId))?.name || details.dayId?.name || "";

    return (
        <Dialog open={open} maxWidth="sm" fullWidth onClose={onClose}>
            <DialogTitle>Quiz Details</DialogTitle>
            <DialogContent sx={{ padding: 5 }}>
                <Typography variant="subtitle1"><b>Question:</b> {details.question}</Typography>
                <Typography variant="subtitle1"><b>Day:</b> {dayName}</Typography>
                <Typography variant="subtitle1"><b>Options:</b></Typography>
                <ul>
                    {details.options?.map((opt, idx) => (
                        <li key={idx}>
                            {opt.title} {opt.correct ? <b style={{ color: 'green' }}>(Correct)</b> : ""}
                        </li>
                    ))}
                </ul>
                {details.image && (
                    <Box mt={2}>
                        <Typography variant="subtitle1"><b>Image:</b></Typography>
                        <a href={`${URL}/${details.image}`} target="_blank" rel="noopener noreferrer">
                            <img src={`${URL}/${details.image}`} alt="quiz" style={{ width: 100, height: 100, objectFit: 'cover' }} />
                        </a>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">Close</Button>
            </DialogActions>
        </Dialog>
    );
};

